var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 6L6.33744 8.72497C7.29971 9.36645 7.78087 9.68722 8.30085 9.81187C8.76045 9.92197 9.23955 9.92197 9.69915 9.81187C10.2191 9.68722 10.7003 9.36645 11.6626 8.72497L15.75 6M4.65 14.25H13.35C14.1901 14.25 14.6102 14.25 14.931 14.0865C15.2132 13.9427 15.4427 13.7132 15.5865 13.431C15.75 13.1101 15.75 12.6901 15.75 11.85V6.15C15.75 5.30992 15.75 4.88988 15.5865 4.56901C15.4427 4.28677 15.2132 4.0573 14.931 3.91349C14.6102 3.75 14.1901 3.75 13.35 3.75H4.65C3.80992 3.75 3.38988 3.75 3.06902 3.91349C2.78677 4.0573 2.5573 4.28677 2.41349 4.56901C2.25 4.88988 2.25 5.30992 2.25 6.15V11.85C2.25 12.6901 2.25 13.1101 2.41349 13.431C2.5573 13.7132 2.78677 13.9427 3.06902 14.0865C3.38988 14.25 3.80992 14.25 4.65 14.25Z",
    stroke: "#197A56",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareTemplate);
export default __webpack_public_path__ + "static/media/shareTemplate.d9dcb226baa368c265a9e498afe61749.svg";
export { ForwardRef as ReactComponent };